import { jsx as _jsx } from "react/jsx-runtime";
import { Toaster } from 'react-hot-toast';
export default function DToastContainer({ containerClassName, position = 'bottom-center', reverseOrder = false, containerStyle, toastOptions, gutter, }) {
    return (_jsx(Toaster, { containerClassName: containerClassName, position: position, reverseOrder: reverseOrder, containerStyle: containerStyle, gutter: gutter, toastOptions: toastOptions }));
}
//# sourceMappingURL=DToastContainer.js.map